
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { TaskFormData } from "@/types/task";

interface Props {
  formData: TaskFormData;
  setFormData: (data: TaskFormData) => void;
}

export const TaskFormBasicInfo = ({ formData, setFormData }: Props) => (
  <>
    <div className="space-y-2 md:col-span-2">
      <Label htmlFor="title" required>عنوان المهمة</Label>
      <Input
        id="title"
        value={formData.title}
        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
        required
        placeholder="أدخل عنوان المهمة"
      />
    </div>
    <div className="space-y-2 md:col-span-2">
      <Label htmlFor="description">الوصف</Label>
      <Textarea
        id="description"
        value={formData.description || ''}
        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        rows={3}
        placeholder="أدخل وصف المهمة"
      />
    </div>
  </>
);
